import state from "@/store/taxcode/state";
import actions from "@/store/taxcode/actions";
import mutations from "@/store/taxcode/mutations";
import getters from "@/store/taxcode/getters";

export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters
};
